import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import { CheckboxItem } from 'lib/designSystem/CheckBoxItem';
import React, { useState } from 'react';

import { PayInExportConfig } from '../types';

interface PayInExportDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (config: PayInExportConfig) => void;
}

const PayInExportDialog: React.FC<PayInExportDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [exportConfig, setExportConfig] = useState<PayInExportConfig>({
    // Por defecto, todos los campos están habilitados
    showOriginInfo: true,
    showDestinationInfo: true,
    showOperationSummary: true,
    showTotalsSummary: true,
    showFolio: true,
    showType: true,
    showClient: true,
    showDebtor: true,
    showPaidBy: true,
    showAmount: true,
    showBalance: true,
    showConciliated: true,
    showRemaining: true,
    showArrearRate: true,
    showConciliationsSummary: true,
  });

  const handleConfirm = () => {
    onConfirm(exportConfig);
    onClose();
  };

  const handleToggle =
    (field: keyof PayInExportConfig) => (checked: boolean) => {
      setExportConfig((prev) => ({
        ...prev,
        [field]: checked,
      }));
    };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Exportar reporte de conciliaciones</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Selecciona qué elementos incluir en el documento PDF.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
            >
              Información general
            </Typography>
            <CheckboxItem
              label="Información de origen"
              checked={exportConfig.showOriginInfo ?? true}
              onChange={handleToggle('showOriginInfo')}
            />
            <CheckboxItem
              label="Información destino"
              checked={exportConfig.showDestinationInfo ?? true}
              onChange={handleToggle('showDestinationInfo')}
            />
            <CheckboxItem
              label="Resumen operación"
              checked={exportConfig.showOperationSummary ?? true}
              onChange={handleToggle('showOperationSummary')}
            />
            <CheckboxItem
              label="Resumen totales"
              checked={exportConfig.showTotalsSummary ?? true}
              onChange={handleToggle('showTotalsSummary')}
            />
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
            >
              Tablas de resumen
            </Typography>
            <CheckboxItem
              label="Conciliaciones"
              checked={exportConfig.showConciliationsSummary ?? true}
              onChange={handleToggle('showConciliationsSummary')}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
            >
              Tabla de documentos
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <CheckboxItem
                  label="Folio"
                  checked={exportConfig.showFolio ?? true}
                  onChange={handleToggle('showFolio')}
                />
                <CheckboxItem
                  label="Tipos"
                  checked={exportConfig.showType ?? true}
                  onChange={handleToggle('showType')}
                />
                <CheckboxItem
                  label="Cliente"
                  checked={exportConfig.showClient ?? true}
                  onChange={handleToggle('showClient')}
                />
                <CheckboxItem
                  label="Deudor"
                  checked={exportConfig.showDebtor ?? true}
                  onChange={handleToggle('showDebtor')}
                />
                <CheckboxItem
                  label="Pagado por"
                  checked={exportConfig.showPaidBy ?? true}
                  onChange={handleToggle('showPaidBy')}
                />
              </Grid>
              <Grid item xs={6}>
                <CheckboxItem
                  label="Monto"
                  checked={exportConfig.showAmount ?? true}
                  onChange={handleToggle('showAmount')}
                />
                <CheckboxItem
                  label="Saldo"
                  checked={exportConfig.showBalance ?? true}
                  onChange={handleToggle('showBalance')}
                />
                <CheckboxItem
                  label="Conciliado"
                  checked={exportConfig.showConciliated ?? true}
                  onChange={handleToggle('showConciliated')}
                />
                <CheckboxItem
                  label="Restante"
                  checked={exportConfig.showRemaining ?? true}
                  onChange={handleToggle('showRemaining')}
                />
                <CheckboxItem
                  label="Detalle de mora"
                  checked={exportConfig.showArrearRate ?? true}
                  onChange={handleToggle('showArrearRate')}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary">
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleConfirm} color="primary">
          Exportar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default PayInExportDialog;
